import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MatchsCcuStat')
export class MatchsCcuStat {

  @JsonProperty('date_hour_timestamp', Number)
  dateHourTimestamp: number = 0;

  @JsonProperty('ccu_count', Number)
  ccuCount: number = 0;
}
